<template>
  <div class="w250">
    <Select
      v-if="provinceList.length"
      v-model="data.nativeProvince"
      placeholder="请选择省"
      class="selectCity"
      @on-change="rovinceChange"
    >
      <Option v-for="ite in provinceList" :value="ite.code" :key="ite.id">{{
        ite.name
      }}</Option>
    </Select>

    <FormItem prop="nativeCity">
      <Select
        v-if="cityList.length"
        v-model="data.nativeCity"
        placeholder="请选择市"
        class="selectCity"
        @on-change="changeCity"
      >
        <Option v-for="ite in cityList" :value="ite.code" :key="ite.id">{{
          ite.name
        }}</Option>
      </Select>
    </FormItem>
  </div>
</template>
<script>
let vm;
export default {
  props: ["cityStatus", "item", "index", "provinceList"],
  data() {
    return {
      data: {},
      i: null,
      cityList: [],
    };
  },
  watch: {
    nativeProvince(newId, oddId) {
      if (newId && newId != "请选择") {
        this.findCityList(newId);
      }
    },
    item(old) {
      this.data = old;
    },
  },
  created() {
    vm = this;
    vm.i = this.index;
    vm.data = this.item;
  },
  mounted() {},
  methods: {
    //市
    findCityList(val, index) {
      vm.$apis.manage
        .findAreaList({
          code: val,
        })
        .then((result) => {
          if (result.messageType == "Success") {
            this.cityList = result.content.areaList;
            // vm.$emit('fun',{'index':vm.i,'item':vm.data});
          }
        });
    },
    //省
    rovinceChange(val) {
      vm.findCityList(val);
      vm.$emit("fun", { index: vm.i, item: vm.data });
    },
    //城市
    changeCity() {
      vm.$emit("fun", { index: vm.i, item: vm.data });
    },
  },
  computed: {
    nativeProvince() {
      return this.data.nativeProvince;
    },
  },
};
</script>
<style scoped lang="scss">
.selectCity {
  // @include vc;
  width: 150px !important;
}
.w250 {
  width: 350px;
}
/deep/ .ivu-form-item {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/city.vue